import {lazy} from "react"

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import ArticleIcon from "@mui/icons-material/Article"
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined"

import {Account, Contact, Dashboard, DomainIcon, Send, Setting} from "../components/common/NdIcons/SvgCollection"
import {buildNatureRoutes} from "./nature-cycle-routes"

/**
 * Every page is reached through `React.lazy` below.
 */
const AccountSetting = lazy(() => import("../views/AccountSetting"))
const Administration = lazy(() => import("../views/Administration"))
const AddEre = lazy(() => import("../components/SendEre/AddEre"))
const AddLegalEntity = lazy(() => import("../views/legalEntity/addLegalEntity/AddLegalEntityPage"))
const ApiUserDetails = lazy(() => import("../components/ApiUser/ApiUserDetails"))
const ApiUsersTable = lazy(() => import("../components/ApiUser/ApiUsersTable"))
const CheckDoc = lazy(() => import("../components/CheckDoc/CheckDoc"))
const ContactDetails = lazy(() => import("../components/Contact/ContactDetails"))
const DocumentDetailsPage = lazy(() => import("../components/Document/Details/DocumentDetailsPage"))
const DocumentTypeDetails = lazy(() => import("../components/DocumentType/DocumentTypeDetails"))
const DomainDetails = lazy(() => import("../components/Domain/DomainDetails"))
const Domains = lazy(() => import("../views/Domains"))
const DomainUserDetails = lazy(() => import("../components/DomainUser/DomainUserDetails"))
const DownloadDocument = lazy(() => import("../views/DownloadDocument"))
const EstablishmentDetailPage = lazy(() => import("../views/establishment/EstablishmentDetailPage"))
const Home = lazy(() => import("../views/Home"))
const InternalDashboard = lazy(() => import("../views/InternalDashBoard"))
const LegalEntityDetailPage = lazy(() => import("../views/legalEntity/legalEntityDetailPage/LegalEntityDetailPage"))
const MetaDataDetails = lazy(() => import("../components/Metadata/MetaDataDetails"))
const OperationDetails = lazy(() => import("../components/Operation/OperationDetails"))
const Register = lazy(() => import("../views/Register"))
const ServiceDetailPage = lazy(() => import("../views/service/ServiceDetailPage"))
const ServiceDetails = lazy(() => import("../components/Service/ServiceDetails"))
const TenantDetails = lazy(() => import("../components/Tenant/TenantDetails"))
const Tenants = lazy(() => import("../views/Tenants"))
const TenantUserDetails = lazy(() => import("../components/TenantUser/TenantUserDetails"))
const ThirdPartyDetails = lazy(() => import("../components/ThirdParty/ThirdPartyDetails"))
const ValidateUser = lazy(() => import("../views/ValidateUser"))

const routes = {
    commonPages: [
        {
            name: "Home",
            url: "/:selectedTab?",
            icon: <Dashboard />,
            roles: ["STANDARD_USER", "DOMAIN_ADMINISTRATOR"],
            component: <Home />,
            isHidden: false,
            IsOffline: false
        }
    ],
    products: [
        {
            id: "nd",
            name: "New Demat",
            pages: [
                {
                    name: "Dashboards",
                    url: "/nd/dashboard/:selectedTab?",
                    icon: <ArticleIcon />,
                    roles: ["STANDARD_USER", "DOMAIN_ADMINISTRATOR"],
                    component: <InternalDashboard />,
                    isHidden: true
                },
                {
                    name: "DownloadDocument",
                    url: "/DownloadDocument/:key",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <DownloadDocument />,
                    IsOffline: true,
                    isHidden: true
                },
                {
                    name: "ValidateUser",
                    url: "/validateuser/:key",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ValidateUser />,
                    IsOffline: true,
                    isHidden: true
                },
                // TODO : route commentée car le tableau n'est pas assez utilisé (ND-1205)
                // {
                //   name: "Operation",
                //   url: "/nd/operation/:selectedTab?",
                //   icon: <Send />,
                //   roles: ["STANDARD_USER"],
                //   component: <Operation />,
                //   keyWords: ["Operation"],
                // },
                {
                    name: "OperationDetail",
                    url: "/nd/operation/:jobType/:id/:selectedTab?",
                    icon: <Send />,
                    roles: ["STANDARD_USER"],
                    component: <OperationDetails />,
                    keyWords: ["Operation"],
                    isHidden: true
                },
                {
                    name: "AddEre",
                    url: "/nd/operation/add/operation/tab/0",
                    icon: <Send />,
                    roles: ["STANDARD_USER"],
                    component: <AddEre />,
                    isHidden: true
                },
                {
                    name: "Register",
                    url: "/nd/register/:selectedTab?",
                    icon: <Contact />,
                    roles: ["STANDARD_USER"],
                    component: <Register />
                },
                {
                    name: "Administration",
                    url: "/nd/administration/index/:selectedTab?",
                    icon: <Setting />,
                    roles: ["STANDARD_USER"],
                    component: <Administration />
                },
                {
                    name: "AddContact",
                    url: "/nd/_register/addContact/:entityId",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ContactDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "AddContactFree",
                    url: "/nd/_register/addContact",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ContactDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "ContactDetailsThirdParti",
                    url: "/nd/register/contactDetails/:id/:entityId",
                    icon: <ContactPageOutlinedIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ContactDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "ContactDetails",
                    url: "/nd/register/contactDetails/:id",
                    icon: <ContactPageOutlinedIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ContactDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "AddThirdParty",
                    url: "/nd/_register/addThirdParty",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ThirdPartyDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "ThirdPartyDetails",
                    url: "/nd/register/thirdpartydetails/:id/:selectedTab?",
                    icon: <ContactPageOutlinedIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ThirdPartyDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "AddTenantUser",
                    url: "/nd/administration/addtenantuser",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <TenantUserDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "DocumentDetail",
                    url: "/nd/documents/:cycle/:oldTab/:documentType/:id/:selectedTab?",
                    icon: <ArticleIcon />,
                    roles: ["STANDARD_USER"],
                    component: <DocumentDetailsPage />,
                    isHidden: true
                },
                {
                    name: "TenantUserDetails",
                    url: "/nd/administration/tenantuserdetails/:id/:userId",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <TenantUserDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "AddLegalEntity",
                    url: "/nd/administration/addlegalentity",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <AddLegalEntity />,
                    isHidden: true
                },
                {
                    name: "AddEstablishment",
                    url: "/nd/administration/addestablishment/:parentStructureId?",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <EstablishmentDetailPage isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "ServiceDetails",
                    url: "/nd/administration/servicedetails/:id/:selectedTab?",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ServiceDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "AddService",
                    url: "/nd/administration/addservice",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ServiceDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "ApiUsers",
                    url: "/nd/administration/apiUsers",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ApiUsersTable />,
                    isHidden: true
                },
                {
                    name: "ApiUserDetails",
                    url: "/nd/administration/apiUserDetails/:id",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ApiUserDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "CheckDoc",
                    url: "/nd/CheckDoc",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <CheckDoc />,
                    isHidden: true
                },
                {
                    name: "AccountSetting",
                    url: "/nd/administration/accountSetting",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <AccountSetting />,
                    isHidden: true
                },
                {
                    name: "AddApiUser",
                    url: "/nd/administration/addApiUser",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["STANDARD_USER"],
                    component: <ApiUserDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "LegalEntityDetail",
                    url: "/nd/administration/legal-entity/:id",
                    component: <LegalEntityDetailPage />,
                    isHidden: true,
                    roles: ["STANDARD_USER"]
                },
                {
                    name: "EstablishmentDetail",
                    url: "/nd/administration/establishment/:id",
                    component: <EstablishmentDetailPage />,
                    isHidden: true,
                    roles: ["STANDARD_USER"]
                },
                {
                    name: "AddServiceDetail",
                    url: "/nd/administration/service/add/:parentStructureId?",
                    component: <ServiceDetailPage isAdd={true} />,
                    isHidden: true,
                    roles: ["STANDARD_USER"]
                },
                {
                    name: "ServiceDetail",
                    url: "/nd/administration/service/:id",
                    component: <ServiceDetailPage />,
                    isHidden: true,
                    roles: ["STANDARD_USER"]
                }
            ]
        },
        {
            id: "da",
            name: "Domain Administration",
            pages: [
                {
                    name: "Domains",
                    url: "/da/domains",
                    icon: <DomainIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <Domains />
                },
                {
                    name: "Tenants",
                    url: "/da/tenants",
                    icon: <Account />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <Tenants />
                },

                {
                    name: "DocumentTypeDetails",
                    url: "/da/tenants/:entityId/DocumentTypeDetails/:id/:selectedTab",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <DocumentTypeDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "AddDocumentTypeDetails",
                    url: "/da/tenants/:entityId/DocumentTypeDetails/:cycle",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <DocumentTypeDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "AddMetaDataDetails",
                    url: "/da/tenants/:entityId/documentType/:id/MetaDataDetails",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <MetaDataDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "MetaDataDetails",
                    url: "/da/tenants/:entityId/:entity/MetaDataDetails/:id/:selectedTab",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <MetaDataDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "MetaDataDetailsTenant",
                    url: "/da/tenants/:tenantId/:entityId/:entity/MetaDataDetails/:id/:selectedTab",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <MetaDataDetails isAdd={false} />,
                    isHidden: true
                },

                {
                    name: "Administration",
                    url: "/da/administration/:selectedTab?",
                    icon: <Setting />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <Administration />
                },
                {
                    name: "DomainUserDetails",
                    url: "/da/:entity/:domainId/domainuserdetails/:id/user/:userId",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <DomainUserDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "AddDomainUser",
                    url: "/da/:entity/:domainId/adddomainuser",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <DomainUserDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "AddTenantUser",
                    url: "/da/tenantUser/addtenantuser/:tenantId?",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <TenantUserDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "TenantUserDetails",
                    url: "/da/tenantUser/tenantuserdetails/:id/:userId/:tenantId?",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <TenantUserDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "DomainDetails",
                    url: "/da/domains/:id/domaindetails/:selectedTab?",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <DomainDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "AccountSetting",
                    url: "/da/administration/accountSetting",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <AccountSetting />,
                    isHidden: true
                },
                {
                    name: "AddDomain",
                    url: "/da/domains/adddomain/:parentDomainId?",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <DomainDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "TenantDetails",
                    url: "/da/tenants/tenantdetails/:id/:selectedTab/:cycle",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <TenantDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "AddTenant",
                    url: "/da/tenants/addtenant/:domainId?",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <TenantDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "ApiUserDetails",
                    url: "/da/administration/apiUser/apiUserDetails/:entity/:entityId/:id",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <ApiUserDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "ApiOtherUserDetails",
                    url: "/da/:entity/apiUser/apiUserDetails/:entityId/:id",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <ApiUserDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "ApiUserDetailsTenent",
                    url: "/da/tenants/apiUser/apiUserDetails/:entity/:entityId/:id",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <ApiUserDetails isAdd={false} />,
                    isHidden: true
                },
                {
                    name: "AddApiUser",
                    url: "/da/:entity?/addApiUser/:entityId?",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <ApiUserDetails isAdd={true} />,
                    isHidden: true
                },
                {
                    name: "AddOwnApiUser",
                    url: "/da/administration/DomainApiKey/addApiUser",
                    icon: <ArrowForwardIosIcon />,
                    roles: ["DOMAIN_ADMINISTRATOR"],
                    component: <ApiUserDetails isAdd={true} />,
                    isHidden: true
                }
            ]
        }
    ]
}

// Find the index of the Register route
const registerIndex = routes.products[0].pages.findIndex((page) => page.name === "Register")

// Insert natureRoutes after Register if found
routes.products[0].pages.splice(registerIndex + 1, 0, ...buildNatureRoutes)

export default routes
